var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',{attrs:{"has-menu":true,"show-menu":_vm.showMenu},on:{"menuSwitch":_vm.menuSwitch}},[_c('user-menu',{model:{value:(_vm.showMenu),callback:function ($$v) {_vm.showMenu=$$v},expression:"showMenu"}}),_c('v-main',{staticClass:"ma-2"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }